import React from "react";

const TABS = [
  { key: "by-practice-area", label: "By Practice Area", path: "/reports/billing/by-practice-area" },
  { key: "summary-by-year", label: "Summary by Year", path: "/reports/billing/summary-by-year" }
];

const BillingNav = ({ active }) => {
  function navigate(e, path) {
    e.preventDefault();
    window.history.pushState({}, "", path);
  }

  return (
    <ul className="billing-nav no-print">
      {TABS.map(tab => (
        <li key={tab.key} className={tab.key === active ? "billing-nav-active" : ""}>
          <a href={tab.path} onClick={(e) => navigate(e, tab.path)}>{tab.label}</a>
        </li>
      ))}
    </ul>
  );
};

export default BillingNav;
